import React, { Component } from 'react';
import { Input } from '@cloud/atom-ui';
import DOMPurify from 'dompurify';
import { replaceHtmlDomain } from "@src/utils/common";

export default class InputSum extends Component {
  state = {
    isShow: true
  }
  clickEvent = () => {
    this.setState({
      isShow: !this.state.isShow
    })
  }

  render() {
    const { item, change } = this.props;
    const { isEdit, value, maxlength, className = '', idName = '', rows = 5, feedbackType } = item;
    let __html = value.replace(/\n/g, '<br/>').replace(/obs.cn-north-7.ulanqab.huawei.com:5443/g, "obs.cn-north-7.ulanqab.huawei.com");
    __html = DOMPurify.sanitize(replaceHtmlDomain(__html));
    return <>
      {isEdit
        ?
        <div id={idName ? idName : ''} className={className} style={{ position: 'relative' }}><Input.TextArea
          placeholder={item.placeholder || ''} maxLength={maxlength} style={{ resize: 'none', paddingBottom: '18px' }} rows={rows}
          defaultValue={value} onChange={(event) => change(event.target.value)}></Input.TextArea><span
            style={{ position: 'absolute', bottom: '0', right: '17px', background: '#fff' }}>{value.length}/{maxlength}</span></div>
        : <>
          {item.canFolded && <div style={{ color: '#008DFF', cursor: 'pointer', marginLeft: '10px', marginTop: '7px' }}
            onClick={this.clickEvent}>{this.state.isShow ? '收起' : '点击展开'}</div>}
          <div className="description" style={{ display: this.state.isShow ? '' : 'none' }}
            dangerouslySetInnerHTML={{ __html }}></div>
        </>
      }


    </>
  }
}
